export const LEDGER_CONTEXT_QUERY_KEYS = Object.freeze({
  reportStartDate: 'reportStartDate',
  reportEndDate: 'reportEndDate',
  reportingCurrency: 'reportingCurrency',
});

function searchParamsFrom(search = '') {
  return new URLSearchParams(String(search || '').replace(/^\?/, ''));
}

export function normalizeHandoffDate(value) {
  const trimmed = String(value ?? '').trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(trimmed) ? trimmed : null;
}

export function normalizeHandoffCurrency(value) {
  const trimmed = String(value ?? '').trim().toUpperCase();
  return /^[A-Z0-9]{2,12}$/.test(trimmed) ? trimmed : null;
}

export function readLedgerContextFromSearch(search = '') {
  const params = searchParamsFrom(search);
  const reportStartDate = normalizeHandoffDate(params.get(LEDGER_CONTEXT_QUERY_KEYS.reportStartDate));
  const reportEndDate = normalizeHandoffDate(params.get(LEDGER_CONTEXT_QUERY_KEYS.reportEndDate));
  const reportingCurrency = normalizeHandoffCurrency(params.get(LEDGER_CONTEXT_QUERY_KEYS.reportingCurrency));
  const hasLedgerContext = Boolean(reportStartDate || reportEndDate || reportingCurrency);

  return {
    hasLedgerContext,
    reportStartDate,
    reportEndDate,
    reportingCurrency,
    basis: hasLedgerContext ? 'ledger-url-handoff' : null,
  };
}

export function readLedgerContextFromBrowser() {
  if (typeof window === 'undefined') {
    return readLedgerContextFromSearch('');
  }
  return readLedgerContextFromSearch(window.location.search);
}
